import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  followUser,
  followUserByUsername,
  getUserByUsername,
  unfollowUser,
  unfollowUserByUsername
} from '../../../apis/discovery.api';
import { UserDTO } from '@twygs/shared/publisher-interface';
import { DataLayer } from '../../../utils/data-layer';

export const useProfile = (username: string) => {
  return useQuery<UserDTO, Error>({
    queryKey: ['profile', username],
    queryFn: async () => {
      const users = await getUserByUsername(username);
      if (!users || users.length === 0) {
        throw new Error('User not found');
      }
      return users[0];
    },
    retry: false,
    staleTime: 5 * 60 * 1000
  });
};

interface FollowMutationVariables {
  username: string;
  isFollowing: boolean;
}

export const useFollowMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, FollowMutationVariables>({
    mutationFn: async ({ username, isFollowing }) => {
      // Track writer follow event when following (not unfollowing)
      if (!isFollowing) {
        DataLayer.trackWriterFollow(username);
      }

      if (isFollowing) {
        return unfollowUserByUsername(username);
      }
      return followUserByUsername(username);
    },
    onSuccess: (_, { username }) => {
      queryClient.invalidateQueries({ queryKey: ['profile', username] });
    }
  });
};
